import { nextTick, onScopeDispose, ref, watch } from 'vue';

const pending = ref(0);
const isDesktop = () => typeof window !== 'undefined' && window.__CORECRY_DESKTOP__ === true;

export function useDesktopStartupTask() {
    if (!isDesktop()) return () => {};
    pending.value += 1;
    let finished = false;
    const finish = () => {
        if (finished) return;
        finished = true;
        pending.value -= 1;
    };
    onScopeDispose(finish);
    return finish;
}

export function useDesktopStartup(authUnknown, route) {
    if (!isDesktop()) return;
    let disposed = false;
    let generation = 0;
    watch([authUnknown, pending, () => route.fullPath], async () => {
        const current = ++generation;
        if (authUnknown.value || pending.value) return;
        await nextTick();
        if (!disposed && current === generation && !authUnknown.value && !pending.value) {
            window.dispatchEvent(new CustomEvent('corecry:desktop-ready'));
        }
    }, { immediate: true, flush: 'post' });
    onScopeDispose(() => { disposed = true; });
}
